import _ from 'underscore';
import { formatMetric } from '@bingads-webui-campaign-legacy/performance-metric-formatter/index';

import tooltipTemplateVNext from './tooltip-template-ui-next.pug';

function formatPoint(point, options) {
  return formatMetric(point.series.options.category, point.y, options);
}

export function formatTooltip({
  points,
  hideCurrency,
}) {
  const originalPoints = [];
  const comparativePoints = [];

  _.each(points, (point) => {
    if (point.series.options.isOriginal) {
      originalPoints.push(point);
    } else if (point.series.options.isComparison) {
      comparativePoints.push(point);
    }
  });

  const tooltip = tooltipTemplateVNext;
  const originalPointsTooltip = _.isEmpty(originalPoints) ?
    '' :
    tooltip({
      title: originalPoints[0].key,
      points: originalPoints,
      formatPoint,
      formatOption: { hideCurrency },
    });

  const comparativePointsTooltip = _.isEmpty(comparativePoints) ?
    '' :
    tooltip({
      // we don't have moving average config for overview performance card
      title: comparativePoints[0].key,
      points: comparativePoints,
      formatPoint,
      formatOption: { hideCurrency },
    });

  const havePop = !_.isEmpty(comparativePoints);
  const className = havePop ? 'perf-graph-tool-tip pop' : 'perf-graph-tool-tip';

  return `<div class="${className}">${originalPointsTooltip}${comparativePointsTooltip}</div>`;
}
